/** The Planosfera mark (the same shapes as `public/favicon.svg`). Decorative: the name is text. */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <rect width="32" height="32" rx="7" fill="var(--color-accent)" />
      <rect x="7" y="8" width="7" height="16" rx="2" fill="var(--color-accent-contrast)" />
      <rect x="18" y="8" width="7" height="10" rx="2" fill="var(--color-accent-contrast)" />
    </svg>
  );
}
